<div class="sx-system-message__contextual-container sxl-flex sxl-column" [ngClass]="cssClass" *ngIf="contextualMessages.length > 0">
  <app-contextual-system-message [contextualMessages]="contextualMessages"></app-contextual-system-message>
</div>
